import type { IntlShape } from "@formatjs/intl";
import { Card, Col, Flex, Form, Input, Row, Select } from "antd";
import { getMaterialCategoryOptions } from "./materialsConstants.ts";

type MaterialFieldsProps = {
  intl: IntlShape;
};

export const MaterialFields = ({ intl }: MaterialFieldsProps) => (
  <Flex vertical gap="middle">
    <Card title={intl.formatMessage({ id: "material_section_details" })}>
      <Row gutter={24}>
        <Col xs={24} md={12}>
          <Form.Item
            name="name"
            label={intl.formatMessage({ id: "material_name" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "validation_message_material_name" }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="category"
            label={intl.formatMessage({ id: "material_category" })}
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "validation_message_material_category",
                }),
              },
            ]}
          >
            <Select options={getMaterialCategoryOptions(intl)} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="sap_code"
            label={intl.formatMessage({ id: "material_batch" })}
          >
            <Input maxLength={240} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  </Flex>
);
